export default __webpack_public_path__ + "static/media/_DSC0371.b15b6e71.JPG";